export default __webpack_public_path__ + "static/media/F0001.d1f5c64e.png";